import { render, staticRenderFns } from "./Multiselectlodgingstyle.vue?vue&type=template&id=58b6a236&"
import script from "./Multiselectlodgingstyle.vue?vue&type=script&lang=js&"
export * from "./Multiselectlodgingstyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports